import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('lock_date_handling'),
    subtitle: defineMessage('how_are_documents_to_be__prior_to_the_lock_date'),
    optionApproveWithNextDay: defineMessage('change_their_date_autom_date_day_after_approval'),
    optionLockDate: defineMessage('lock_the_document_until__created_in_approvalmax'),
    optionLockDateXeroOnly: defineMessage('lock_the_document_until_hanged_manually_in_xero'),
    optionLockDateAmaxOnly: defineMessage('lock_the_document_until_manually_in_approvalmax'),
};
